export const COUNTRY_CODES = {
  CHILE: 'CL',
  URUGUAY: 'UY'
}

export const DEFAULT_COUNTRY_CODE = COUNTRY_CODES.CHILE

export const COUNTRY_DETAILS = {
  [COUNTRY_CODES.CHILE]: {
    name: 'Chile',
    iso3Code: 'CHL',
    mapboxCountry: 'cl',
    defaultCity: 'santiago',
    defaultCoordinates: [-70.610672, -33.417752],
    phonePrefix: '+56',
    phoneLength: 9,
    currencyDecimals: 0,
    regionLabel: 'Región',
    districtLabel: 'Comuna',
    documentLabel: 'Rut',
    invalidDocumentMessage: 'Rut inválido'
  },
  [COUNTRY_CODES.URUGUAY]: {
    name: 'Uruguay',
    iso3Code: 'URY',
    mapboxCountry: 'uy',
    defaultCity: 'montevideo',
    defaultCoordinates: [-56.164531, -34.901112],
    phonePrefix: '+598',
    phoneLength: 8,
    currencyDecimals: 2,
    regionLabel: 'Departamento',
    districtLabel: 'Localidad',
    documentLabel: 'CI',
    invalidDocumentMessage: 'CI inválida'
  }
}

export const URUGUAY_CI_WEIGHTS = [2, 9, 8, 7, 6, 3, 4]

export const URUGUAY_CI_LENGTH = {
  MIN: 7,
  MAX: 8
}

export const URUGUAY_RUT_WEIGHTS = [4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]

export const URUGUAY_RUT_LENGTH = 12

export const URUGUAY_PHONE_PATTERN = /^[249]\d{7}$/

export const URUGUAY_PHONE_TRUNK_PREFIX = /^0/

export const URUGUAY_DEPARTMENT_PREFIX = /^Departamento de /
export const URUGUAY_LEADING_POSTCODE = /^\d{5}\s/
export const CHILE_TRAILING_POSTCODE = /\s\d{7}$/
